import axios from './axiosClient'
 
const productAPI = {
    getListProduct: () =>{
        const url = '/Products/invoiceable'
       return axios.get(url)
    },
}

export default productAPI;